import { startTransition, useEffect, useOptimistic, useState } from "react";
import { IoIosArrowForward, IoIosArrowUp } from "react-icons/io";
import { ExButton } from "../../../components/ExButton";
import { ExSwitch } from "../../../components/ExSwitch";
import { Col, Row } from "react-bootstrap";
import { useAuth } from "../../../contexts/AuthProvider/useAuth";
import React from "react";

interface Grupo {
    usucodigo: number;
    gruid: number;
    gruidpai: number | null;
    grudescricao: string;
    usugruler: number;
    usugruincluir: number;
    usugrualterar: number;
    usugruexcluir: number;
}

const InnerView = ({ gruposProjetados, getDados, gruposCadastrados, auth }: any) => {
    //const auth = useAuth();

    //const [expandedNodes, setExpandedNodes] = useState<Set<number>>(new Set());
    const [optimisticState, setOptimisticState] = useOptimistic<any>(gruposProjetados)

    console.log(optimisticState?.find((e: any) => e.gruid === 1 && e.usucodigo === 1))

    async function updateStatus(_body: any) {
        let body = {
            gruid: _body.gruid,
            usucodigo: _body.usucodigo,
            usugruler: _body.usugruler,
            usugruincluir: _body.usugruincluir,
            usugrualterar: _body.usugrualterar,
            usugruexcluir: _body.usugruexcluir,
        }

        startTransition(() => {
            console.log('add')

            //(state: any[], action) => [
            const aux = optimisticState.map((e: any) => e.gruid === body.gruid && e.usucodigo === body.usucodigo ? { ...e, ...body, sending: true } : { ...e })
            //]

            setOptimisticState(aux)
            //addOptimistic(body)

            try {
                auth.post('/v1/usuariogrupoupsert', body).then(() => {
                    getDados()
                });
            } catch (error) {
                console.log(error);
            }
        })
    }

    const renderGrupoTree = (projetados: Grupo[], gruidpai: number | null, level: number = 0): React.JSX.Element[] => {
        const toggleNode = (id: number) => {
            // setExpandedNodes(prev => {
            //     const newExpandedNodes = new Set(prev);
            //     if (newExpandedNodes.has(id)) {
            //         newExpandedNodes.delete(id);
            //     } else {
            //         newExpandedNodes.add(id);
            //     }
            //     return newExpandedNodes;
            // });
        };

        function existGrupoCadastrado(gruid: number) {
            return gruposCadastrados.some((grupo: any) => grupo.gruid === gruid);
        }

        return projetados
            .filter(grupo => grupo.gruidpai === gruidpai)
            .map(grupo => {
                const isExpanded = true//expandedNodes.has(grupo.gruid);
                const childs = optimisticState?.filter((g: any) => g.gruidpai === grupo.gruid);
                const hasChildren = childs && childs.length > 0;

                return (
                    <div key={grupo.gruid} style={{ padding: '8px 0px' }}>
                        <Row style={{ opacity: existGrupoCadastrado(grupo.gruid) ? '100%' : '25%' }}>
                            <Col>
                                <div style={{ marginLeft: hasChildren ? level * 38 : ((level + 1) * 38), display: 'flex' }} >
                                    {hasChildren && (
                                        <ExButton
                                            onClick={() => toggleNode(grupo.gruid)}
                                            style={{ display: 'flex', justifyContent: 'center', marginRight: '8px', borderRadius: '50%', width: '30px', height: '30px', paddingLeft: 0, paddingRight: 0 }}
                                            iconcenter={isExpanded ? <IoIosArrowUp /> : <IoIosArrowForward />}
                                        />
                                    )}
                                    <span >{grupo.grudescricao}</span>
                                </div>
                            </Col>
                            <Col><ExSwitch checked={grupo.usugruler === 1 && grupo.usugrualterar === 1 && grupo.usugruexcluir === 1 && grupo.usugruincluir === 1} onChange={(e: any) => updateStatus({ ...grupo, usugruler: e.target.checked ? 1 : 0, usugruincluir: e.target.checked ? 1 : 0, usugrualterar: e.target.checked ? 1 : 0, usugruexcluir: e.target.checked ? 1 : 0 })} /></Col>
                            <Col><ExSwitch checked={grupo.usugruler === 1} onChange={(e: any) => updateStatus({ ...grupo, usugruler: e.target.checked ? 1 : 0 })} /></Col>
                            <Col><ExSwitch checked={grupo.usugruincluir === 1} onChange={(e: any) => updateStatus({ ...grupo, usugruincluir: e.target.checked ? 1 : 0 })} /></Col>
                            <Col><ExSwitch checked={grupo.usugrualterar === 1} onChange={(e: any) => updateStatus({ ...grupo, usugrualterar: e.target.checked ? 1 : 0 })} /></Col>
                            <Col><ExSwitch checked={grupo.usugruexcluir === 1} onChange={(e: any) => updateStatus({ ...grupo, usugruexcluir: e.target.checked ? 1 : 0 })} /></Col>
                        </Row>
                        {isExpanded && renderGrupoTree(projetados, grupo.gruid, level + 1)}
                    </div>
                );
            });
    };

    return (
        <div>
            {renderGrupoTree(optimisticState, null)}
        </div>
    )
}

export const TreeGroup = (props: any) => {
    const [gruposCadastrados, setGruposCadastrados] = useState<Grupo[]>([]);
    const [gruposProjetados, setGruposProjetados] = useState<Grupo[]>([]);

    const auth = useAuth();
    console.log('parent')
    useEffect(() => {
        getDados();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // useEffect(() => {
    //     setExpandedNodes(initializeExpandedNodes());

    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [gruposProjetados]);

    async function getDados() {
        try {
            const responseProjetados: any = await auth.get('/v1/usuariogrupoprojetado');
            const filteredProjetados = responseProjetados.data.filter((item: any) => item.usucodigo === props.usucodigo);

            const responseCadastrados: any = await auth.get('/v1/usuariogrupo');
            const filteredCadastrados = responseCadastrados.data.filter((item: any) => item.usucodigo === props.usucodigo);

            setGruposProjetados(filteredProjetados);
            setGruposCadastrados(filteredCadastrados);
        } catch (error) {
            console.log(error);
        }
    }

    // const initializeExpandedNodes = (): Set<number> => {
    //     return new Set(gruposProjetados.map(grupo => grupo.gruid));
    // };

    return (
        <div style={{ padding: '5px 0' }}>
            <Row style={{ fontWeight: 'bold', padding: '8px 0' }}>
                <Col>Grupo</Col>
                <Col>Todos</Col>
                <Col>Ler</Col>
                <Col>Incluir</Col>
                <Col>Alterar</Col>
                <Col>Excluir</Col>
            </Row>
            <InnerView gruposProjetados={gruposProjetados} getDados={getDados} gruposCadastrados={gruposCadastrados} auth={auth} />
        </div>
    );
};
